import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

import { StatisticWithLabelAndCountProps } from './types';

export default makeStyles((theme: typeof muiTheme) => ({
    labelStyle: {
        color: theme?.app?.applicationColors.fontLabelColor || '#727272',
        fontSize: '.75rem',
        fontWeight: 'bold' as 'bold',
        textTransform: 'uppercase' as 'uppercase'
    },
    statisticStyle: {
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        fontSize: '2rem'
    },
    countContainer: {
        alignSelf: 'center' as 'center',
        marginLeft: '1.25rem'
    },
    countStyle: {
        backgroundColor: (props: StatisticWithLabelAndCountProps) => (props.statistic.lockCount ?
            (theme?.app?.applicationColors.enumColors.offWhite || '#EFEFEF')
            : 'inherit'),
        color: (props: StatisticWithLabelAndCountProps) => (
            props.statistic.lockCount &&
            props.statistic.statisticCount !== '0' &&
            props.statistic.statisticCount !== '-' ?
                (theme?.app?.applicationColors.lockColor || '#F5824A')
                : (theme?.app?.applicationColors.fontColor || '#202020')),
        fontSize: '1rem',
        border: (props: StatisticWithLabelAndCountProps) => (
            props.statistic.lockCount ?
                'none'
                : `1px solid ${theme?.app?.clientTheme.colors.primaryColorLight || '#0294D4'}`),
        borderRadius: '3px',
        padding: '0 .35rem'
    },
    lockIcon: {
        height: '18px',
        width: '18px',
        paddingLeft: '.3rem'
    }
}));